import React, { useState } from "react";
import "./style.css";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { HiOutlineArrowDownTray, HiOutlineDocumentText } from "react-icons/hi2";
import { Link, NavLink, useLocation } from "react-router-dom";
import { logotext, socialprofils } from "../../data/content_option";
import Themetoggle from "../themetoggle";

const Headermain = () => {
  const location = useLocation();
  const [isActive, setActive] = useState(true);
  const cvDownloadUrl = "https://drive.google.com/uc?export=download&id=1_DDTQ9R6IeB_bk7prXfS3id2653PNzaH";

  const handleToggle = () => {
    setActive(!isActive);
    document.body.classList.toggle("ovhidden");
  };

  const handleSamePageClick = ({ targetPath, targetHash = "", closeMobileMenu = false }) => (event) => {
    const samePath = location.pathname === targetPath;
    const sameHash = (location.hash || "") === targetHash;

    if (samePath && sameHash) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });

      if (closeMobileMenu && !isActive) {
        handleToggle();
      }
      return;
    }

    if (closeMobileMenu && !isActive) {
      handleToggle();
    }
  };

  return (
    <>
      <header className="fixed-top site__header shadow-md p-1">
        <div className="d-flex align-items-center justify-content-between">
          <Link
            className="navbar-brand nav_ac"
            to="/"
            onClick={handleSamePageClick({ targetPath: "/" })}
          >
            {logotext}
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop__nav d-none d-md-flex gap-4 align-items-center">
            <NavLink
              to="/"
              end
              onClick={handleSamePageClick({ targetPath: "/" })}
              className={({ isActive: navActive }) => `nav_link${navActive ? " active" : ""}`}
            >
              Overview
            </NavLink>
            <NavLink
              to="/work-showcase"
              onClick={handleSamePageClick({ targetPath: "/work-showcase" })}
              className={({ isActive: navActive }) => `nav_link${navActive ? " active" : ""}`}
            >
              View Projects
            </NavLink>
            <NavLink
              to="/profile"
              onClick={handleSamePageClick({ targetPath: "/profile" })}
              className={({ isActive: navActive }) => `nav_link${navActive ? " active" : ""}`}
            >
              Profile
            </NavLink>
            <NavLink
              to="/contact"
              onClick={handleSamePageClick({ targetPath: "/contact" })}
              className={({ isActive: navActive }) => `nav_link${navActive ? " active" : ""}`}
            >
              Contact
            </NavLink>
            <a
              href={cvDownloadUrl}
              className="cv-main-button"
              download="manimohan_cv.pdf"
              aria-label="Download CV"
            >
              <HiOutlineDocumentText />
              <span>Download CV</span>
              <HiOutlineArrowDownTray />
            </a>

            <Themetoggle />
          </nav>

          {/* Mobile Menu Button */}
          <div className="d-md-none d-flex align-items-center">
            <Themetoggle />
            <button
              type="button"
              className="menu__button nav_ac ms-2"
              onClick={handleToggle}
              aria-label={isActive ? "Open navigation menu" : "Close navigation menu"}
              aria-expanded={!isActive}
              aria-controls="mobile-navigation"
            >
              {!isActive ? <VscClose /> : <VscGrabber />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div id="mobile-navigation" className={`site__navigation ${!isActive ? "menu__opend" : ""}`}>
          <div className="bg__menu h-100">
            <div className="menu__wrapper">
              <div className="menu__container p-3">
                <ul className="the_menu">
                  <li className="menu_item">
                    <NavLink
                      end
                      onClick={handleSamePageClick({ targetPath: "/", closeMobileMenu: true })}
                      to="/"
                      className={({ isActive: navActive }) => `my-3${navActive ? " active" : ""}`}
                    >
                      Overview
                    </NavLink>
                  </li>
                  <li className="menu_item">
                    <NavLink
                      onClick={handleSamePageClick({ targetPath: "/work-showcase", closeMobileMenu: true })}
                      to="/work-showcase"
                      className={({ isActive: navActive }) => `my-3${navActive ? " active" : ""}`}
                    >
                      View Projects
                    </NavLink>
                  </li>
                  <li className="menu_item">
                    <NavLink
                      onClick={handleSamePageClick({ targetPath: "/profile", closeMobileMenu: true })}
                      to="/profile"
                      className={({ isActive: navActive }) => `my-3${navActive ? " active" : ""}`}
                    >
                      Profile
                    </NavLink>
                  </li>
                  <li className="menu_item">
                    <NavLink
                      onClick={handleSamePageClick({ targetPath: "/contact", closeMobileMenu: true })}
                      to="/contact"
                      className={({ isActive: navActive }) => `my-3${navActive ? " active" : ""}`}
                    >
                      Contact
                    </NavLink>
                  </li>
                  <li className="menu_item">
                    <a
                      onClick={handleToggle}
                      href={cvDownloadUrl}
                      download="manimohan_cv.pdf"
                      className="my-3"
                      aria-label="Download CV as PDF"
                    >
                      Download CV
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>

          <div className="menu_footer d-flex flex-column flex-md-row justify-content-between align-items-md-center position-absolute w-100 p-3">
            <div className="d-flex gap-3">
              <a href={socialprofils.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">LinkedIn</a>
              <a href={socialprofils.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub profile">GitHub</a>
              <a href={socialprofils.medium} target="_blank" rel="noopener noreferrer" aria-label="Medium profile">Medium</a>
            </div>
            <p className="copyright m-0">Copyright {new Date().getFullYear()} {logotext}</p>
          </div>
        </div>
      </header>
    </>
  );
};

export default Headermain;
